import React from "react";
import { Row, Col } from "react-bootstrap";
import SelectDatas from "./../PopUp/SelectData";
import { Grid } from "@mui/material";
export default class data1 extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      Maingroup: props.p1_1,
      Subgroup1: props.p1_2,
    };

    console.log("propsdata1", props.p1_2);
  }
  SelectSetData = async (type, data) => {
    var data1 = "";
    switch (type) {
      case "Maingroup":
        data1 = type + "|" + data;
        break;
      case "Subgroup1":
        data1 = type + "|" + data;
        break;
      default:
        break;
    }
    this.props.Getdata("data1", data1);
  };
  render() {
    return (
      <Grid container spacing={2}>
        <Grid item xs={8}>
          <SelectDatas
            origin="Maingroup" // กลุ่มลูกค้าหลัก
            valueSelect={(e) => this.SelectSetData("Maingroup", e)} // รับค่ากลับ
            title="กลุ่มลูกค้าหลัก"
            defaultselect={this.state.Maingroup} // ค่าเริ่มต้นของ กลุ่มลูกค้าหลัก
          />
        </Grid>
        <Grid item xs={8}>
          <SelectDatas
            origin="Subgroup1" // กลุ่มลูกค้าย่อย 1
            valueSelect={(e) => this.SelectSetData("Subgroup1", e)} // รับค่ากลับ
            title="กลุ่มลูกค้าย่อย 1"
            defaultselect={this.state.Subgroup1} // ค่าเริ่มต้นของ กลุ่มลูกค้าย่อย 1
          />
        </Grid>
      </Grid>
    );
  }
}
